import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// On route change: scroll to top unless the URL carries a hash (e.g. "/#reviews"),
// in which case scroll that element into view instead. Short setTimeout lets
// the destination route finish mounting before we look up the anchor.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      // Try immediately (in case the target is already in the tree), then
      // again after a tick to catch lazy-loaded sections / late mounts.
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      scroll();
      const t = setTimeout(scroll, 250);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}
